import type { FleetMissionType } from '@kaeliux/shared';
import type { IconName } from '../components/ui/iconPaths';
import type { Tone } from '../components/ui/toneStyles';

export const MISSION_ICON: Record<FleetMissionType, IconName> = {
    attack: 'attack',
    pirate: 'attack',
    sunAttack: 'zone-military',
    espionage: 'spy',
    sunDefence: 'zone-military',
    sunGarrison: 'zone-military',
    transport: 'cargo',
    station: 'starport',
    colonize: 'planet',
    harvestAsteroid: 'asteroid',
    recycle: 'scrap',
    spaceTrip: 'fleets',
};

export const MISSION_TONE: Record<FleetMissionType, Tone> = {
    attack: 'danger',
    pirate: 'danger',
    sunAttack: 'danger',
    espionage: 'warning',
    sunDefence: 'warning',
    sunGarrison: 'info',
    transport: 'info',
    station: 'info',
    colonize: 'success',
    harvestAsteroid: 'neutral',
    recycle: 'neutral',
    spaceTrip: 'neutral',
};
